export const capitalize = (str) => str.replace(/./, (w) => w.toUpperCase())
